<!--<div class="control has-icons-left">-->
<!--  <input class="input is-small" type="text" placeholder="Search" i18n-placeholder="Search"-->
<!--    (change)="onSearchInputChange($event)">-->
<!--  <span class="icon is-small is-left">-->
<!--    <i-feather name="search" class="icon-smaller"></i-feather>-->
<!--  </span>-->
<!--  <span class="icon is-small is-right is-clickable" (click)="showSearchInfo($event)">-->
<!--    <i-feather name="help-circle" class="icon-smaller"></i-feather>-->
<!--  </span>-->
<!--</div>-->

<div class="scroll-wrapper" infiniteScroll (scrolled)="onScroll()" [scrollWindow]="false" [ngStyle]="{'max-height': maxHeight}">
  <table class="table is-narrow is-hoverable is-fullwidth table-compact">
    <thead>
      <tr>
        @if (showIndex) {
          <th class="has-text-right" style="width: 50px">#</th>
        }
        @for (column of columns; track column; let i = $index) {
          <th (click)="sortBy(column)" [ngStyle]="{'width': getColumnType(column) === 'number' ? '120px' : 'initial'}">
            <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center"
              [ngClass]="[getColumnType(column) === 'number' ? 'is-justify-content-flex-end' : 'is-justify-content-flex-start']">
              @if (sorting && sorting.field === column) {
                @if (sorting.direction === 'ASC') {
                  <i-feather class="sort-direction-indicator" name="chevron-up"></i-feather>
                } @else {
                  <i-feather class="sort-direction-indicator" name="chevron-down"></i-feather>
                }
              } @else {
                @if (this.sortableColumns.includes(column)) {
                  <i-feather class="sort-direction-indicator" name="chevron-right"></i-feather>
                }
              }
              {{getColumnLabel(column)}}
            </div>
          </th>
        }
      </tr>
    </thead>
    <tbody >
      @for (plot of filteredPlots; track plot; let i = $index) {
        <tr (click)="onPlotClick($event, plot, i)"
          [ngClass]="{'is-selected': selectedPlotIds && selectedPlotIds.indexOf(plot.id) !== -1}">
          @if (showIndex) {
            <td class="has-text-right">{{i}}</td>
          }
          @for (column of columns; track column) {
            <td title="{{plot.getAsString(column)}}" [class]="getCellClass(plot, column)"
              [ngClass]="[getColumnType(column) === 'number' ? 'has-text-right' : 'has-text-left']">
              {{plot.getAsString(column)}}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
